import { Injectable } from '@angular/core';
import {TreeServiceClass} from '@app/core/libraries/Tree/core/classes/treeService.class';

@Injectable({
  providedIn: 'root'
})
export class TreeService extends TreeServiceClass {
}
